export const removeEmptyValues = (obj) => {
    let newObj = {};
    Object.keys(obj).forEach((prop) => {
        if (prop === 'use_local_tz') { newObj[prop] = obj[prop]; }
        if (obj[prop]) { newObj[prop] = obj[prop]; }
    });
    return newObj;
};